import { ChronoDtoSchema } from "@modules/chrono/services/chronoDtos"
import { z } from "zod"

export const BenchmarkDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  category: z.string(),
  chrono: ChronoDtoSchema.nullable(),
  isFavorite: z.boolean(),
})

export type BenchmarkDto = z.infer<typeof BenchmarkDtoSchema>
